<template>
  <div class="legend-item">
    <span
      class="dot"
      :style="`background-color:${dotColor}`"
      v-if="dotColor"
      :class="{ isSquare }"
    />
    <img :src="symbol.slice(8)" class="symbol" v-else-if="symbol" />
    <span class="name" :style="`color: ${textColor ? textColor : 'inherit'}`">
      {{ name }}
    </span>
  </div>
</template>

<script>
export default {
  name: "legend-item",
  props: {
    dotColor: String,
    name: String,
    symbol: String,
    isSquare: Boolean,
    textColor: String,
  },
};
</script>

<style lang="scss" scoped>
.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .dot,
  .symbol {
    display: block;
    margin-right: toRem(10);
  }
  .symbol {
    width: 13px;
    height: 13px;
  }
  .dot {
    border-radius: 50%;
    width: 19px;
    height: 19px;
    &.isSquare {
      border-radius: 0;
    }
  }
  .name {
    color: v-bind(textColor);
  }
}
</style>